import { getLocaleBasedDateFormat } from '@thoughtspot/date-format-util';
import { getFormatPattern } from '@thoughtspot/formatter-service';
import { translate } from '@thoughtspot/i18n';
import { isDynamicTitleSupported, isRenamingColumnsEnabled, } from '@thoughtspot/session-service';
import { ChartSpecificColumnType, ColumnAggregationType, ColumnTimeBucket, ColumnType, DataType, FormatType, } from '@thoughtspot/ts-chart-sdk';
import { getBaseColumnName, getColumnId, getCustomOrder, getName as getColumnName, getSourceName, getTrueEffectiveAggregateType, } from '@thoughtspot/visualization-column-util';
import { AnswerColumnFormatType, } from '../types/prism';
import { isMeasureNameColumn, isMeasureValueColumn, omitTypenameProperty, } from './common-util';
import { getNumberFormatting } from './custom-chart-formatting.utils';
const getColumnFormat = (column) => {
    const formatType = column.formatType ?? AnswerColumnFormatType.None;
    const formatPattern = getFormatPattern(column);
    if (column.format) {
        const pattern = formatPattern
            ? getLocaleBasedDateFormat(formatPattern)
            : column.format.pattern;
        return {
            ...omitTypenameProperty(column.format),
            type: FormatType[formatType],
            pattern,
        };
    }
    if (formatPattern) {
        return {
            type: FormatType.PATTERN,
            pattern: getLocaleBasedDateFormat(formatPattern),
            currencyFormat: null,
        };
    }
    return null;
};
export const getName = (col, skipPrefix = false) => {
    if (isMeasureNameColumn(col) || isMeasureValueColumn(col)) {
        if (col?.isUserDefinedTitle) {
            return isRenamingColumnsEnabled()
                ? col?.name
                : getColumnName(col, translate, skipPrefix);
        }
        return '';
    }
    return isRenamingColumnsEnabled() && col?.isUserDefinedTitle
        ? col?.name
        : getColumnName(col, translate, skipPrefix);
};
export const getDynamicTitle = (col) => {
    if (!isDynamicTitleSupported() || !col.dynamicTitle) {
        return getName(col);
    }
    return col.dynamicTitle;
};
export const mapAnswerColumnToCustomColumns = (column, columnProperty) => {
    const chartSpecificColumnType = ChartSpecificColumnType[column.chartSpecificColumnType];
    const columnType = chartSpecificColumnType
        ? ColumnType.VIRTUAL
        : ColumnType[column.type];
    const customOrder = getCustomOrder(column);
    const filteredCustomOrder = customOrder
        ? customOrder.filter(item => item !== '')
        : customOrder;
    return {
        id: getColumnId(column),
        name: getBaseColumnName(column),
        type: columnType,
        chartSpecificColumnType: chartSpecificColumnType ?? ChartSpecificColumnType.UNKNOWN,
        timeBucket: ColumnTimeBucket[column.timeBucket],
        dataType: Object.values(DataType).includes(column.dataType)
            ? DataType[column.dataType]
            : DataType.UNKNOWN,
        format: getColumnFormat(column),
        customOrder: filteredCustomOrder,
        aggregationType: ColumnAggregationType[getTrueEffectiveAggregateType(column)],
        calenderGuid: column?.calendarGuid,
        columnProperties: {
            conditionalFormatting: columnProperty?.conditionalFormatting || null,
            numberFormatting: getNumberFormatting(column),
        },
        displayName: getName(column),
        dynamicTitle: getDynamicTitle(column),
        showGrowth: column.showGrowth,
        isAggregateApplied: column.isAggregateApplied,
        dataSourceName: getSourceName(column, translate),
        ...(column.formulaId && { formulaId: column.formulaId }),
    };
};
export const mapLegacyColumnsToCustomColumns = (allColumns, columnProperties = []) => {
    return allColumns.map((col) => {
        const column = col.column;
        const columnProp = columnProperties.find(prop => prop.columnId === column.id);
        return mapAnswerColumnToCustomColumns(column, columnProp?.columnProperty);
    });
};
//# sourceMappingURL=answer-column-adaptor.util.js.map